import React from "react";
import { Container, BlogImage, BlogDetails } from "./styles";
import { navigate } from "gatsby";

const BlogPreview = ({ id, image, title, date, author, tags, content }) => {
  let editedTitle = title.replace(/\s/g, "-").replace(/[^a-zA-Z0-9]/g, "-");
  return (
    <Container onClick={() => navigate(`/blog#${editedTitle}`)}>
      <BlogImage>
        <img src={image} className="blog-img" alt="blog" />
      </BlogImage>
      <h1 className="blog-title">{title}</h1>
      <BlogDetails>
        <div className="header">
          <div className="slider-ish">
            <span className="date">
              <p className="">{date}</p>
            </span>
            {author && (
              <span className="author">
                <p className="">{author}</p>
              </span>
            )}
          </div>

          <div className="tags">
            {tags.map((tag, index) => (
              <p key={index}>
                {tag}
                {index !== tags.length - 1 && "/"}
              </p>
            ))}
          </div>
        </div>
      </BlogDetails>
      {content && <p className="blog-content">{content.slice(0, 90)}</p>}
    </Container>
  );
};

export default BlogPreview;
